import {
  Button as MantineButton,
  type ButtonProps as MantineButtonProps,
  type ElementProps,
} from "@mantine/core";
import { forwardRef } from "react";
import { type ButtonVariant } from "./variants";

type DSButtonProps = {
  variant?: ButtonVariant;
} & Omit<MantineButtonProps, "variant"> &
  ElementProps<"button", keyof MantineButtonProps>;

const variantMap: Record<ButtonVariant, Partial<MantineButtonProps>> = {
  primary: { variant: "filled", color: "R500" },
  danger: { variant: "filled", color: "V500" },
  ghost: { variant: "transparent", color: "plain_text" },
  outline: { variant: "outline", color: "R500" },
};

const Button = forwardRef<HTMLButtonElement, DSButtonProps>(
  ({ variant = "primary", ...props }, ref) => {
    const mantineProps = variantMap[variant];

    return (
      <MantineButton
        ref={ref}
        {...mantineProps}
        {...props}
      />
    );
  }
);

Button.displayName = "DSButton";

export default Button;
export type { DSButtonProps as ButtonProps };
